import { useEffect, useRef } from 'react'

const useMounted = () => {
  const didMountRef = useRef(false)
  useEffect(() => {
    didMountRef.current = true
    return () => {
      didMountRef.current = false
    }
  }, [])
  return didMountRef.current
}

export default useMounted
